import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const Dashboard = () => {
  const history = useLocation();

  let currentPath = history.pathname;

  return (
    <main className="pb-24">
      <div className="drawer drawer-mobile">
        <input
          id="dashboardSidebar"
          type="checkbox"
          className="drawer-toggle"
        />
        <div className="drawer-content mx-5">
          <h2 className="text-2xl font-bold text-primary">Admin Dashboard</h2>
          <Outlet></Outlet>
        </div>
        <div className="drawer-side ">
          <label htmlFor="dashboardSidebar" className="drawer-overlay"></label>
          <ul className="menu p-4 overflow-y-auto w-48 bg-base-100 text-base-content">
            {/* <!-- Sidebar content here --> */}
            <li>
              <Link
                to="/hello-gas/admin/dashboard"
                className={
                  currentPath === "/hello-gas/admin/dashboard" ? "active" : ""
                }
              >
                Dashboard
              </Link>
            </li>
            <li>
              <Link
                to="/hello-gas/admin/dashboard/allBrands"
                className={
                  currentPath === "/hello-gas/admin/dashboard/allBrands"
                    ? "active"
                    : ""
                }
              >
                Manage Brands
              </Link>
            </li>
            <li>
              <Link
                to="/hello-gas/admin/dashboard/allProducts"
                className={
                  currentPath === "/hello-gas/admin/dashboard/allProducts"
                    ? "active"
                    : ""
                }
              >
                Manage Products
              </Link>
            </li>
            <li>
              <Link
                to="/hello-gas/admin/dashboard/allOrders"
                className={
                  currentPath === "/hello-gas/admin/dashboard/allOrders"
                    ? "active"
                    : ""
                }
              >
                Manage Orders
              </Link>
            </li>
            <li>
              <Link
                to="/hello-gas/admin/dashboard/allConfirmOrders"
                className={
                  currentPath === "/hello-gas/admin/dashboard/allConfirmOrders"
                    ? "active"
                    : ""
                }
              >
                Confirm Orders
              </Link>
            </li>
            <li>
              <Link
                to="/hello-gas/admin/dashboard/allCompleteOrders"
                className={
                  currentPath === "/hello-gas/admin/dashboard/allCompleteOrders"
                    ? "active"
                    : ""
                }
              >
                Complete Orders
              </Link>
            </li>
            <li>
              <Link
                to="/hello-gas/admin/dashboard/addBrand"
                className={
                  currentPath === "/hello-gas/admin/dashboard/addBrand"
                    ? "active"
                    : ""
                }
              >
                Add Brand
              </Link>
            </li>
            <li>
              <Link
                to="/hello-gas/admin/dashboard/addProduct"
                className={
                  currentPath === "/hello-gas/admin/dashboard/addProduct"
                    ? "active"
                    : ""
                }
              >
                Add Product
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
